module.exports = __webpack_public_path__ + "img/section4BtnIconm.0f1488ba.svg";